import createPalette from '@sift/skipper/styles/createPalette';

export default createPalette({
  marketing: {
    purples: {
      phlox: '#ae00ff',
      fuschia: '#9d00ff',
      electric: '#8300ff',
      fig: '#7512ff',
      veronica: '#6100ff',
      gladiolus: '#4e00bc',
      monkshood: '#4b01b4',
      deep: '#3d0091',
    },
  },
});
